<template>
  <input
    :type="type"
    :name="name"
    :value="props.modelValue"
    class="
      nib-text-input
      shadow-sm
      focus:ring-gray-400 focus:border-gray-400
      block
      w-full
      sm:text-sm
      border-gray-300
      rounded-md
    "
    :placeholder="placeholder"
    @input="emits('update:modelValue', handleEventTarget($event))"
  />
</template>

<script setup lang="ts">
interface Props {
  modelValue?: string | boolean | number;
  type?: string;
  name?: string;
  placeholder?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  type: "text",
  name: "",
  placeholder: "",
});

const emits = defineEmits(["update:modelValue"]);

const handleEventTarget = (event: any) => {
  return (event.target as HTMLInputElement).value;
};
</script>

<style lang="postcss" scoped>
input:read-only {
  @apply bg-gray-200 cursor-not-allowed pointer-events-none;
}
input.nib-text-input {
  min-height: 40px;
}
</style>
